import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: '28px'
  },

  search: {
    margin: '0',
    border: '1px solid #C6C6C6',
    borderRadius: '4px',
    boxSizing: 'border-box',
    padding: ({ hideIcon }) => (hideIcon ? '0' : '0 0 0 40px'),
    height: '100%',
    width: '100%',
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    outline: 'none',
    background: '#F5F6F8',

    '&::placeholder': {
      color: '#888888 !important'
    },

    '&:focus': {
      borderColor: '#B64FCD'
    }
  },

  icon: {
    position: 'absolute',
    left: '17px'
  },

  loading: {
    width: '16px !important',
    height: '16px !important'
  }
}))

export default useStyles
